// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"715":"323fede9","760":"52b70ca1","874":"c711bf16","919":"c711bf16"}[chunkId] + ".chunk.css";
};